import { type ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface PaginatedListEmptyProps {
  className?: string;
  message: ReactNode;
}

export const PaginatedListEmpty = ({ className, message }: PaginatedListEmptyProps) => (
  <div
    data-slot="paginated-list-empty"
    className={cn("flex flex-1 items-center justify-center p-6 text-sm text-muted-foreground", className)}
  >
    {message}
  </div>
);
